export function panelMainClass(hasLeftPanel: boolean, hasRightPanel: boolean): string {
  const base = 'content-list-panel-main flex min-w-0 flex-col gap-10 pt-30';

  if (hasLeftPanel && hasRightPanel) {
    return `${base} content-list-panel-main--both`;
  }
  if (hasLeftPanel) {
    return `${base} content-list-panel-main--left-only`;
  }
  if (hasRightPanel) {
    return `${base} content-list-panel-main--right-only`;
  }
  return base;
}
